
export enum StepType
{
    AddToBasket = "AddToBasket",
    Payment = "Payment",
    PersonalPickup = "PersonalPickup",
    PackageToCustomer = "PackageToCustomer",
    Training = "Training",
    Usage = "Usage",
    PersonalReturn = "PersonalReturn",
    PackageFromCustomer = "PackageReturn",
    PaymentReturn = "PaymentReturn",
    ManaPostalDelivery = "ManaPostalDelivery",
    Invoice = "Invoice",
    Event = "Event",
}


export const StepTypeNames = {
    [StepType.AddToBasket]: "🛒 Zamówienie",
    [StepType.Payment]: "💳 Wpłata",
    [StepType.PersonalPickup]: "🐤 Odbiór osobisty",
    [StepType.PackageToCustomer]: "📦 Wysyłka do klienta",
    [StepType.Training]: "🎓 Szkolenie",
    [StepType.Usage]: "🚀 Użycie",
    [StepType.PersonalReturn]: "🐥 Zwrot osobisty",
    [StepType.PackageFromCustomer]: "📮 Zwrot paczką",
    [StepType.PaymentReturn]: "💸 Zwrot środków",
    [StepType.ManaPostalDelivery]: "📯 Przekaz pieniężny",
    [StepType.Invoice]: "🗃️ Faktura",
    [StepType.Event]: "⚡ Wydarzenie",
}
